import React from "react";
import TimberTypeListItem from "../../components/timberType/TimberTypeList/TimberTypeListItem";
import {Box} from "@mui/material";
import {useParams} from "react-router";
import {useTitle} from 'react-use';
import { t } from "@lingui/core/macro";

const TimberTypeListPage = ()  => {

    useTitle(t`List Timber Type`);
    
    const allQueries = useParams()
    const query = Object.fromEntries(
        Object.entries(allQueries).filter(([key]) => key.endsWith("Id"))
    )
    
    return (
        <Box>
            <TimberTypeListItem showAdd={true} {...query} />
        </Box>
    )
}

export default TimberTypeListPage;
